module.exports = __webpack_public_path__ + "static/media/C_E02.9fe564a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_E02.png
// module id = 95
// module chunks = 0